export const EMPLOYEE_STATUS_APPROVED = 1;

export const EMPLOYEE_STATE_INACTIVE = 0;
export const EMPLOYEE_STATE_READY = 1;
export const EMPLOYEE_STATE_TRAINING = 2;